import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const MARUNAGE_ROWS = [
  { journalsPerMonth: '月間仕訳数　100件まで', annualSales: 'だいたい年商 1,000万円以内', price: '¥8,800' },
  { journalsPerMonth: '月間仕訳数　200件まで', annualSales: 'だいたい年商 2,000万円以内', price: '¥22,000' },
  { journalsPerMonth: '月間仕訳数　300件まで', annualSales: 'だいたい年商 3,000万円以内', price: '¥25,000' },
];

const SELF_ROWS = [
  { journalsPerMonth: '月間仕訳数　100件まで', annualSales: 'だいたい年商 1,000万円以内', price: '¥5,500' },
  { journalsPerMonth: '月間仕訳数　200件まで', annualSales: 'だいたい年商 2,000万円以内', price: '¥8,250' },
  { journalsPerMonth: '月間仕訳数　300件まで', annualSales: 'だいたい年商 3,000万円以内', price: '¥11,000' },
];

const WEB_INITIAL_PLANS = [
  {
    plan: 'シンプルプラン',
    description: 'サロンプロフィールページ 1枚もの',
    price: '¥11,000',
    note: null,
    icon: 'ri-file-list-3-line',
    sampleUrl: 'https://zenwest-sample02.readdy.co',
  },
  {
    plan: '広告プラン',
    description: '広告用LP（集客に特化したランディングページ）',
    price: '¥33,000',
    note: null,
    icon: 'ri-megaphone-line',
    sampleUrl: null,
  },
  {
    plan: 'ベーシックプラン',
    description: 'サロン紹介とお申込みサイト作成（3〜5ページ）',
    price: '¥55,000',
    note: '追加1ページにつき ¥5,500',
    icon: 'ri-pages-line',
    sampleUrl: 'https://zenwest-sample01.readdy.co',
  },
];

const WEB_MAINTENANCE_PLANS = [
  {
    plan: 'シンプルプラン',
    description: '月1回メンテナンス',
    price: '¥3,300',
  },
  {
    plan: 'ベーシックプラン',
    description: '月3回までメンテナンス＋月1回ページ分析レポート作成',
    price: '¥5,500',
  },
  {
    plan: 'SEO対策プラン',
    description: '月3回までメンテナンス＋月1回SEO検索エンジン対策',
    price: '¥16,500',
  },
];

const WEB_OPTIONS = [
  { label: 'カメラマン写真撮影派遣', icon: 'ri-camera-line' },
  { label: 'キャッチコピー作成代行', icon: 'ri-pen-nib-line' },
  { label: 'ホームページ原稿作成代行', icon: 'ri-article-line' },
  { label: 'パソコン周りのセッティング（メール設定、プリンタ接続など）', icon: 'ri-computer-line' },
];

const FAQS = [
  {
    q: '仕訳数って何ですか？自分がどのくらいか分かりません',
    a: '仕訳数とは、1ヶ月の入出金・売上などの取引件数のことです。例えば、1日にカード払い・現金払い・銀行振込が合わせて5件あれば、1ヶ月で約100〜150件程度になります。正確な件数が分からなくても、年商をお教えいただければ目安でお伝えできます。まずはお気軽にご相談ください。',
    category: '料金・プラン',
  },
  {
    q: '依頼するには何を準備すればいいですか？',
    a: '基本的にはレシート・領収書をまとめてお渡しいただければOKです。紙のままでもスマホで撮影したデータでも対応しています。クラウド会計（freee・弥生会計など）をすでにお使いであれば、アクセス共有をしていただくだけで始められます。まだご利用でない場合は、ご一緒に初期設定から行います。',
    category: '料金・プラン',
  },
  {
    q: '月途中からでも依頼できますか？',
    a: 'はい、いつからでも依頼していただけます。月の途中や、年の途中からのご依頼も対応しています。前月分や前期分の整理もご相談いただけますので、お気軽にお声がけください。',
    category: '料金・プラン',
  },
  {
    q: '契約の縛りや解約の条件はありますか？',
    a: '最低利用期間などの縛りはありません。月単位でのご契約ですので、1ヶ月前にご連絡いただければいつでも解約できます。',
    category: '料金・プラン',
  },
  {
    q: 'やりとりはどうやって行いますか？直接来てもらえますか？',
    a: 'お客様のサロンへご訪問のほか、コワーキングスペースでの対面、ZoomやGoogle Meetを使ったオンライン対応も行っています。書類のやりとりはPDF・写真メールで対応しています。大阪府外の方もオンラインにてご対応可能です。',
    category: 'サービス・対応',
  },
  {
    q: '確定申告もお願いできますか？',
    a: '帳簿の整理・記帳代行はお任せいただけます。確定申告書の作成・提出は税理士の独占業務となるため、Zenwestでは行っておりません。ただし、記帳データを整理してお渡しすることで、提携の税理士や自身での申告がスムーズになります。税理士のご紹介もご相談ください。',
    category: 'サービス・対応',
  },
  {
    q: 'クラウド会計（freee・弥生会計）を使ったことがないのですが大丈夫ですか？',
    a: 'まったく問題ありません。これまで使ったことがない方へのサポートも得意です。一緒にアカウント作成・初期設定から行います。操作方法もわかりやすくお伝えしますので、スマホが苦手な方でも安心してご利用いただけます。',
    category: 'クラウド会計',
  },
  {
    q: '料金の支払い方法は何がありますか？',
    a: '銀行振込での対応を基本としております。月末締め・翌月払いとなります。振込手数料はご負担をお願いしております。その他の支払い方法についてはご相談ください。',
    category: '料金・プラン',
  },
  {
    q: 'ホームページの完成までどのくらいかかりますか？',
    a: 'シンプルプランで約1〜2週間、ベーシックプランで2〜4週間が目安です。お写真や原稿のご準備状況によって前後することがあります。お急ぎの場合はご相談ください。',
    category: 'ホームページ作成',
  },
  {
    q: '独自ドメイン（専用アドレス）とは何ですか？費用はかかりますか？',
    a: '独自ドメインとは「salon-name.com」のような、自分だけの専用ウェブアドレスのことです。取得する際は年間管理費として¥11,000〜（毎年更新）が別途必要になります。取得代行・初期設定も含めてZenwestがサポートしますので、ご安心ください。',
    category: 'ホームページ作成',
  },
  {
    q: '記帳代行とホームページ作成を一緒に依頼できますか？',
    a: 'もちろんです。記帳代行と合わせてご依頼いただくことも大歓迎です。経理まわりとIT・ホームページまわりをまとめてお任せいただけますので、手間が減ってとても好評です。',
    category: 'ホームページ作成',
  },
];

const CATEGORIES = ['すべて', '料金・プラン', 'サービス・対応', 'クラウド会計', 'ホームページ作成'];

const INCLUDED_SERVICES = [
  'レシート・領収書の整理・仕訳入力',
  '月次試算表の作成',
  'クラウド会計（freee・弥生会計など）の操作サポート',
  'メール・LINEでの随時質問対応',
  'お客様のサロンへの訪問 or オンライン対応',
  '年2回の経営相談（30〜60分）',
];

const NOTES = [
  'お客様には別途クラウド会計（弥生会計・freee等）のご登録が必要です。',
  '月間仕訳数が300件を超える場合はご相談ください。お見積もりいたします。',
  'お急ぎの場合は特急料金をいただく場合がございます。詳しくはご相談ください。',
  '補助金・助成金申請のサポートも承っております。お気軽にご相談ください。',
];

function PricingTable({ rows }: { rows: typeof MARUNAGE_ROWS }) {
  return (
    <>
      {/* Desktop Table */}
      <div className="hidden md:block rounded-2xl overflow-hidden border border-gray-100">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#1A2332] text-white">
              <th className="px-6 py-4 text-left font-semibold">月間仕訳数</th>
              <th className="px-6 py-4 text-center font-semibold">年商の目安</th>
              <th className="px-6 py-4 text-right font-semibold">月額料金（税込）</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className={`border-b border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                <td className="px-6 py-5 font-semibold text-[#1A2332]">{row.journalsPerMonth}</td>
                <td className="px-6 py-5 text-center text-gray-500 text-xs">{row.annualSales}</td>
                <td className="px-6 py-5 text-right">
                  <span className="text-2xl font-extrabold text-[#0EA5E9]">{row.price}</span>
                  <span className="text-gray-400 text-xs ml-1">/月</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-4">
        {rows.map((row, i) => (
          <div key={i} className="rounded-2xl p-6 border border-gray-100 bg-white">
            <p className="font-bold text-[#1A2332] mb-1">{row.journalsPerMonth}</p>
            <p className="text-xs text-gray-400 mb-3">{row.annualSales}</p>
            <p className="text-2xl font-extrabold text-[#0EA5E9]">{row.price}<span className="text-sm font-normal text-gray-400 ml-1">/月（税込）</span></p>
          </div>
        ))}
      </div>
    </>
  );
}

export default function PricingPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeCategory, setActiveCategory] = useState('すべて');
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ハッシュによるスクロール処理
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const tryScroll = (attempts: number) => {
        const el = document.getElementById(id);
        if (el) {
          // ナビバーの高さ分オフセット
          const navHeight = 80;
          const top = el.getBoundingClientRect().top + window.scrollY - navHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        } else if (attempts > 0) {
          setTimeout(() => tryScroll(attempts - 1), 150);
        }
      };
      setTimeout(() => tryScroll(5), 100);
    }
  }, [location.hash]);

  // トップページのお問い合わせフォームにスクロール
  const goToContact = () => {
    navigate('/', { state: { scrollTo: 'contact' } });
  };

  const filteredFaqs = activeCategory === 'すべて'
    ? FAQS
    : FAQS.filter(f => f.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white border-b border-gray-100' : 'bg-white/90 backdrop-blur-sm'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <img src="https://static.readdy.ai/image/f9c7a126b558a9be781ef4c29ae5dafc/8ebc0db39f9829cf06d07a5266fdf192.png" alt="Zenwest Logo" className="h-10 w-10 object-contain" />
              <div>
                <p className="text-2xl font-bold text-[#1A2332]">Zenwest</p>
                <p className="text-xs text-[#0EA5E9]">会計＆ITサポート</p>
              </div>
            </Link>
            <div className="flex items-center gap-6">
              <Link to="/" className="text-sm text-gray-500 hover:text-[#0EA5E9] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5">
                <i className="ri-arrow-left-line"></i>
                トップページへ戻る
              </Link>
              <button
                onClick={goToContact}
                className="bg-[#0EA5E9] text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-[#1A2332] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                無料相談予約
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <div className="pt-24 pb-16 bg-gradient-to-br from-[#1A2332] to-[#1A2332]/90">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-[#0EA5E9] text-sm font-semibold tracking-wider uppercase mb-3">Pricing &amp; FAQ</p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">サービス料金・よくある質問</h1>
          <p className="text-white/70 text-lg">プランの詳細と、みなさんからよくいただく質問をまとめました</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-20">

        {/* ======= 記帳代行サービス セクション区切り ======= */}
        <div className="relative flex items-center gap-4 mb-16">
          <div className="flex-1 h-px bg-gray-200"></div>
          <div className="flex items-center gap-2 shrink-0 bg-white border border-gray-200 px-5 py-2 rounded-full">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-file-list-3-line text-[#0EA5E9]"></i>
            </div>
            <span className="text-sm font-bold text-[#1A2332]">記帳代行サービス</span>
          </div>
          <div className="flex-1 h-px bg-gray-200"></div>
        </div>

        {/* 完全丸投げプラン */}
        <section className="mb-20" id="bookkeeping-pricing">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 bg-[#0EA5E9]/10 text-[#0EA5E9] text-xs font-bold px-4 py-1.5 rounded-full mb-4">
              <i className="ri-folder-2-line"></i>
              完全丸投げプラン
            </div>
            <h2 className="text-3xl font-extrabold text-[#1A2332] mb-2">領収書を渡すだけ、入力はこちらが行います</h2>
            <p className="text-gray-500 text-sm">帳簿の入力・整理・月次試算表の作成まで、すべてZenwestにお任せいただけるプランです。</p>
          </div>

          <PricingTable rows={MARUNAGE_ROWS} />

          {/* 含まれるサービス */}
          <div className="mt-8 bg-gray-50 rounded-2xl p-6">
            <p className="text-sm font-bold text-[#1A2332] mb-4">全プラン共通の含まれるサービス</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {INCLUDED_SERVICES.map((item, i) => (
                <div key={i} className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center bg-[#0EA5E9] rounded-full shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* セルフ入力サポートプラン */}
        <section className="mb-16">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 bg-[#1A2332]/10 text-[#1A2332] text-xs font-bold px-4 py-1.5 rounded-full mb-4">
              <i className="ri-user-heart-line"></i>
              セルフ入力サポートプラン
            </div>
            <h2 className="text-3xl font-extrabold text-[#1A2332] mb-2">クラウド入力はご自身で、確認・サポートをお任せ</h2>
            <p className="text-gray-500 text-sm">自分でも管理できるようになりたい方・コストを抑えたい方に向けたプランです。</p>
          </div>

          <PricingTable rows={SELF_ROWS} />

          {/* セルフプランの含まれるサービス */}
          <div className="mt-8 bg-gray-50 rounded-2xl p-6">
            <p className="text-sm font-bold text-[#1A2332] mb-4">このプランに含まれるサービス</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {[
                'クラウド入力内容の確認・アドバイス',
                '仕訳ルールの指導・レクチャー',
                '月1回の内容チェックレポート',
                'メール・LINEでの随時質問対応',
                'クラウド会計の初期設定サポート',
                '年2回の経営相談（30〜60分）',
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center bg-[#1A2332] rounded-full shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 補足事項 */}
        <section className="mb-20">
          <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-information-line text-amber-500 text-lg"></i>
              </div>
              <p className="text-sm font-bold text-amber-800">ご利用にあたっての補足事項</p>
            </div>
            <ul className="space-y-2.5">
              {NOTES.map((note, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-amber-900">
                  <span className="text-amber-400 font-bold shrink-0 mt-0.5">※</span>
                  <span>{note}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* ======= ホームページ作成料金 セクション区切り ======= */}
        <div className="relative flex items-center gap-4 mb-16">
          <div className="flex-1 h-px bg-gray-200"></div>
          <div className="flex items-center gap-2 shrink-0 bg-white border border-gray-200 px-5 py-2 rounded-full">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-global-line text-[#0EA5E9]"></i>
            </div>
            <span className="text-sm font-bold text-[#1A2332]">ホームページ作成サービス</span>
          </div>
          <div className="flex-1 h-px bg-gray-200"></div>
        </div>

        {/* ホームページ 初期導入費用 */}
        <section className="mb-16" id="web-pricing">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 text-xs font-bold px-4 py-1.5 rounded-full mb-4">
              <i className="ri-store-3-line"></i>
              初期導入費用
            </div>
            <h2 className="text-3xl font-extrabold text-[#1A2332] mb-2">ホームページ作成プラン</h2>
            <p className="text-gray-500 text-sm">サロンの目的・規模に合わせて3つのプランをご用意しています。</p>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block rounded-2xl overflow-hidden border border-gray-100 mb-4">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[#1A2332] text-white">
                  <th className="px-6 py-4 text-left font-semibold">プラン</th>
                  <th className="px-6 py-4 text-left font-semibold">内容</th>
                  <th className="px-6 py-4 text-right font-semibold">初期費用（税込）</th>
                </tr>
              </thead>
              <tbody>
                {WEB_INITIAL_PLANS.map((row, i) => (
                  <tr key={i} className={`border-b border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                    <td className="px-6 py-5">
                      <div className="flex items-center gap-2">
                        <div className="w-7 h-7 flex items-center justify-center bg-emerald-50 rounded-lg shrink-0">
                          <i className={`${row.icon} text-emerald-600 text-sm`}></i>
                        </div>
                        <span className="font-bold text-[#1A2332] whitespace-nowrap">{row.plan}</span>
                      </div>
                    </td>
                    <td className="px-6 py-5 text-gray-600">
                      <p>{row.description}</p>
                      {row.note && (
                        <p className="text-xs text-gray-400 mt-1">+ {row.note}</p>
                      )}
                      {row.sampleUrl && (
                        <a
                          href={row.sampleUrl}
                          target="_blank"
                          rel="noopener noreferrer nofollow"
                          className="inline-flex items-center gap-1 text-xs text-emerald-600 hover:text-emerald-800 mt-2 cursor-pointer"
                        >
                          <i className="ri-external-link-line text-xs"></i>
                          見本サイトを見る
                        </a>
                      )}
                    </td>
                    <td className="px-6 py-5 text-right">
                      <span className="text-2xl font-extrabold text-emerald-600">{row.price}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4 mb-4">
            {WEB_INITIAL_PLANS.map((row, i) => (
              <div key={i} className="rounded-2xl p-6 border border-gray-100 bg-white">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-7 h-7 flex items-center justify-center bg-emerald-50 rounded-lg shrink-0">
                    <i className={`${row.icon} text-emerald-600 text-sm`}></i>
                  </div>
                  <p className="font-bold text-[#1A2332]">{row.plan}</p>
                </div>
                <p className="text-sm text-gray-600 mb-1">{row.description}</p>
                {row.note && <p className="text-xs text-gray-400 mb-1">+ {row.note}</p>}
                {row.sampleUrl && (
                  <a
                    href={row.sampleUrl}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-1 text-xs text-emerald-600 hover:text-emerald-800 mb-3 cursor-pointer"
                  >
                    <i className="ri-external-link-line text-xs"></i>
                    見本サイトを見る
                  </a>
                )}
                <p className="text-2xl font-extrabold text-emerald-600">{row.price}<span className="text-sm font-normal text-gray-400 ml-1">（税込）</span></p>
              </div>
            ))}
          </div>

          {/* ドメイン注記 */}
          <div className="flex items-start gap-2.5 bg-gray-50 rounded-xl px-5 py-4">
            <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
              <i className="ri-information-line text-gray-400"></i>
            </div>
            <p className="text-xs text-gray-500">自分専用のアドレス（独自ドメイン）を取得する場合は、別途ドメイン管理費として年間 ¥11,000〜 が必要です。</p>
          </div>
        </section>

        {/* 保守費用 */}
        <section className="mb-16">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 bg-violet-50 text-violet-700 text-xs font-bold px-4 py-1.5 rounded-full mb-4">
              <i className="ri-tools-line"></i>
              保守費用（月額・税込）
            </div>
            <h2 className="text-3xl font-extrabold text-[#1A2332] mb-2">公開後のサポートプラン</h2>
            <p className="text-gray-500 text-sm">ページの修正・更新・SEO対策など、継続サポートもお任せください。</p>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block rounded-2xl overflow-hidden border border-gray-100">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[#1A2332] text-white">
                  <th className="px-6 py-4 text-left font-semibold">プラン</th>
                  <th className="px-6 py-4 text-left font-semibold">サービス内容</th>
                  <th className="px-6 py-4 text-right font-semibold">月額料金（税込）</th>
                </tr>
              </thead>
              <tbody>
                {WEB_MAINTENANCE_PLANS.map((row, i) => (
                  <tr key={i} className={`border-b border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                    <td className="px-6 py-5 font-bold text-[#1A2332] whitespace-nowrap">{row.plan}</td>
                    <td className="px-6 py-5 text-gray-600 text-sm">{row.description}</td>
                    <td className="px-6 py-5 text-right">
                      <span className="text-2xl font-extrabold text-violet-600">{row.price}</span>
                      <span className="text-gray-400 text-xs ml-1">/月</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {WEB_MAINTENANCE_PLANS.map((row, i) => (
              <div key={i} className="rounded-2xl p-6 border border-gray-100 bg-white">
                <p className="font-bold text-[#1A2332] mb-1">{row.plan}</p>
                <p className="text-xs text-gray-500 mb-3">{row.description}</p>
                <p className="text-2xl font-extrabold text-violet-600">{row.price}<span className="text-sm font-normal text-gray-400 ml-1">/月（税込）</span></p>
              </div>
            ))}
          </div>
        </section>

        {/* オプション */}
        <section className="mb-20">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 bg-orange-50 text-orange-600 text-xs font-bold px-4 py-1.5 rounded-full mb-4">
              <i className="ri-add-circle-line"></i>
              オプション
            </div>
            <h2 className="text-3xl font-extrabold text-[#1A2332] mb-2">単品でもご依頼いただけます</h2>
            <p className="text-gray-500 text-sm">料金はご要望に応じてお見積もりします。お気軽にご相談ください。</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {WEB_OPTIONS.map((opt, i) => (
              <div key={i} className="flex items-center gap-4 bg-white border border-gray-100 rounded-2xl px-6 py-4">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-xl shrink-0">
                  <i className={`${opt.icon} text-orange-500 text-lg`}></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#1A2332]">{opt.label}</p>
                  <p className="text-xs text-gray-400 mt-0.5">料金はご相談ください</p>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-orange-50 border border-orange-100 rounded-2xl px-6 py-5">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-lightbulb-line text-orange-400"></i>
              </div>
              <p className="text-sm text-orange-800">その他、IT関係のお悩みもお気軽にご相談ください。「こんなことも頼めるの？」という小さなことでも大歓迎です。</p>
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <div className="bg-gradient-to-r from-[#0EA5E9] to-[#0EA5E9]/80 rounded-2xl p-8 text-center mb-20">
          <h3 className="text-2xl font-bold text-white mb-2">どのプランか迷ったら</h3>
          <p className="text-white/90 text-sm mb-6">まずは無料相談で、お話をお聞かせください。最適なプランをご提案します。</p>
          <button
            onClick={goToContact}
            className="inline-block bg-white text-[#0EA5E9] font-bold px-10 py-3.5 rounded-full hover:bg-[#1A2332] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            無料相談を予約する
          </button>
        </div>

        {/* FAQ */}
        <section id="faq">
          <div className="text-center mb-10">
            <p className="text-[#0EA5E9] text-sm font-semibold tracking-wider uppercase mb-3">FAQ</p>
            <h2 className="text-3xl font-extrabold text-[#1A2332] mb-3">よくある質問</h2>
            <p className="text-gray-500 text-sm">ご依頼前に気になること、まとめました</p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-[#1A2332] text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="space-y-3">
            {filteredFaqs.map((faq, i) => (
              <div key={i} className="border border-gray-100 rounded-xl overflow-hidden bg-white">
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-start gap-3">
                    <span className="text-[#0EA5E9] font-bold text-sm shrink-0 mt-0.5">Q</span>
                    <span className="text-sm font-semibold text-[#1A2332]">{faq.q}</span>
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i className={`ri-${openFaq === i ? 'subtract' : 'add'}-line text-gray-400 text-lg`}></i>
                  </div>
                </button>
                {openFaq === i && (
                  <div className="px-6 pb-5">
                    <div className="flex gap-3">
                      <span className="text-[#1A2332] font-bold text-sm shrink-0 mt-0.5">A</span>
                      <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-sm text-gray-500 mb-4">上記に当てはまらないご質問もお気軽にどうぞ</p>
            <button
              onClick={goToContact}
              className="inline-flex items-center gap-2 bg-[#0EA5E9] text-white font-semibold px-8 py-3.5 rounded-full hover:bg-[#1A2332] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-message-3-line"></i>
              お問い合わせはこちら
            </button>
          </div>
        </section>
      </div>

      {/* Footer */}
      <footer className="bg-[#1A2332] text-white py-10 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-3">
            <img src="https://static.readdy.ai/image/f9c7a126b558a9be781ef4c29ae5dafc/8ebc0db39f9829cf06d07a5266fdf192.png" alt="Zenwest Logo" className="h-8 w-8 object-contain" />
            <p className="text-xl font-bold">Zenwest</p>
          </div>
          <p className="text-sm text-gray-400 mb-4">美容室・ネイルサロン・エステサロン専門 会計＆ITサポート</p>
          <p className="text-xs text-gray-500">&copy; 2025 Zenwest. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
